import { demoDocuments } from "./demo-documents";

export const documentsQuery = {
  read(_: any) {
    return demoDocuments;
  },
};
